module.exports = __webpack_public_path__ + "img/4.74780706.webp";